
import { Context } from '@nuxt/types'
import { mapGetters } from 'vuex'
import CommonSalesDialog from '../../components/common/CommonSalesDialog.vue'
import MachinationsLightPage from '~/domain/pages/MachinationsLightPage'
import { PricingFeatureBanner } from '~/domain/interfaces/PricingTypes'
import AppActions from '~/domain/constants/AppActions'
import { trackLinkedinAds, planHasCustomQuote } from '~/domain/helpers/helpers'
import { PRODUCT_KEYS } from '~/domain/constants/PricingConst'
import PricingPageSkeletonLoader from '~/components/loaders/PricingPageSkeletonLoader.vue'
import CommonEducationBrandsBlock from '~/components/common/CommonEducationBrandsBlock.vue'

export default MachinationsLightPage.extend({
  name: 'PricingPage',
  layout: 'machinations',
  components: {
    CommonEducationBrandsBlock,
    PricingPageSkeletonLoader,
    CommonSalesDialog,
  },
  head() {
    // @ts-ignore
    const pageHead = this.pageHead()
    return {
      ...pageHead,
      title: `Pricing`,
    }
  },
  data() {
    return {
      billingCycle: 'yearly',
      sendEventToSegment: true,
      dataProdConfig: [],
      dataPlanFeatures: [],
      isLoading: true,
    }
  },

  async fetch() {},

  async asyncData(context: Context): Promise<void> {
    const { store } = context

    await store.dispatch('common/setupPageLight', { context })
    await store.dispatch('pricing/fetchPricingData', { context })
    await store.dispatch('wp/fetchPageBySlug', { context, slug: 'pricing-wip' })
  },
  computed: {
    ...mapGetters({
      prodConfig: 'pricing/getProdConfig',
      planFeatures: 'pricing/getPlanFeatures',
      getConfigForActivePlans: 'pricing/getConfigForActivePlans',
      getDisplayedProdConfig: 'pricing/getDisplayedProdConfig',
      userDetails: 'pricing/pricingUserDetails',
      acfData: 'wp/getAcfData',
    }),
    displayedProdConfig() {
      return this.getDisplayedProdConfig(
        this.$t('currentPlan'),
        this.isPartnerUrl
      )
    },
    planIds() {
      const flipped = Object.entries(PRODUCT_KEYS).map(([key, stringVal]) => [
        stringVal,
        key,
      ])
      const ids = {}
      flipped.forEach(([key, value]: any) => {
        ids[key] = parseInt(value)
      })
      return ids
    },
    banner(): PricingFeatureBanner {
      return {
        title: this.acfData?.banner?.title,
        tag: this.acfData?.banner?.tag,
        badgeText: this.acfData?.banner?.badge || this.$t('new'),
        description: this.acfData?.banner?.description,
        buttonText: this.acfData?.banner?.sales_dialog?.button_label,
        buttonUrl: this.acfData?.banner?.sales_dialog?.url,
        secondaryButtonText:
          this.acfData?.banner?.secondary_button?.button_label,
        secondaryButtonUrl: this.acfData?.banner?.secondary_button?.button_url,
        salesDialog: this.acfData?.banner?.sales_dialog,
      }
    },

    logoBelt(): any {
      return {
        title: this.acfData?.logo_belt?.title,
        introIcons: this.acfData?.logo_belt?.intro_icons,
        logo: this.acfData?.logo_belt?.intro_icons?.logo,
      }
    },

    cta() {
      return {
        usp: this.acfData?.cta?.usp,
        uspTitle: this.acfData?.cta?.usp?.title,
        uspSubtitle: this.acfData?.cta?.usp?.subtitle,
      }
    },
    ctaSalesDialog() {
      return {
        dialogId: this.acfData?.cta?.sales_dialog?.dialog_id,
        dialogType: this.acfData?.cta?.sales_dialog?.dialog_type,
      }
    },

    salesDialogId(): string {
      return this.acfData?.banner?.sales_dialog?.dialog_id
    },
    salesDialogType(): string {
      return this.acfData?.banner?.sales_dialog?.dialog_type
    },
    pageHero() {
      return ''
    },
    isPartnerUrl() {
      // TODO: remove
      return this.$route.query.upgrade === 'powerplanpartner'
    },
    showSubtitle(): boolean {
      // @ts-ignore
      return this.userDetails?.trialUsed && this.userDetails?.activePlan === this.planIds.community
    },
    customSubtitle(): string {
      return this.showSubtitle ? 'comparePlansNotEligibleForTrial' : ''
    },
  },

  methods: {
    planClicked({ planId, billingCycle }) {
      this.$store.dispatch('user/updateSubscriptionPlan', {
        context: this,
        planId,
        billingCycle,
      })
      if (planHasCustomQuote(planId)) {
        // @ts-ignore
        this.$refs.calendlySalesDialogRef.talkToSalesClicked()
      }
    },

    bannerClicked(): void {
      trackLinkedinAds('book-demo')
      this.$store.dispatch(
        AppActions.TRACK_SEGMENT_EVENT,
        {
          context: this,
          params: {
            name: 'Custom Quote - Intent',
            category: 'Micro conversion',
            action: 'Custom Quote Intent',
            label: 'www_pricing_main',
            misc: [
              {
                type: 'location',
                value: 'www_pricing_main',
              },
            ],
          },
        },
        { root: true }
      )
      // @ts-ignore
      this.$nextTick(() =>this.$refs?.calendlySalesDialogRef?.talkToSalesClicked())
    },

    ctaClicked(): void {
      // @ts-ignore
      this.$nextTick(() =>this.$refs?.typeformSalesDialogRef?.talkToSalesClicked())
    },

    customQuoteClicked(location: string): void {
      trackLinkedinAds('book-demo')
      this.$store.dispatch(
        AppActions.TRACK_SEGMENT_EVENT,
        {
          context: this,
          params: {
            name: 'Custom Quote - Intent',
            category: 'Micro conversion',
            action: 'Custom Quote Intent',
            label: location,
            misc: [
              {
                type: 'location',
                value: location,
              },
            ],
          },
        },
        { root: true }
      )
      // @ts-ignore
      this.$refs.calendlySalesDialogRef.talkToSalesClicked()
    },

    getQuote(url: string) {
      window.open(url, '_blank')
    },
  },

  mounted() {
    if (this.$route.query['bookDemo']) {
      const target = document.getElementById('mpk-feature-banner-wrapper-sales')
      if (process.browser) {
        if (target) {
          setTimeout(() => {
            const offsetPosition = target.getBoundingClientRect().top - 100
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth',
            })
          }, 500)
        }
      }
    }
    this.isLoading = false
  },
})
